import React from "react";
import "./Footer.css";
import logoImg from "../assets/logos/logo_holistique.avif";
import linkedInIcon from "../assets/socialMedia/linkedin.webp";
import youTubeIcon from "../assets/socialMedia/youtube.webp";
import whatsappIcon from "../assets/socialMedia/whatsapp.webp";
import instagramIcon from "../assets/socialMedia/instagram.webp";
import facebookIcon from "../assets/socialMedia/facebook.webp";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img className="footer-logo" src={logoImg} loading="lazy" width="220" height="150" alt="Holistique_logo" />
        <p className="footer-copy">© 2025 HOLISTIQUE Health & Beauty Hub©.</p>
        <div className="footer-social-media">
          <a href="https://www.linkedin.com/company/somosholistique/">
            <img src={linkedInIcon} loading="lazy" width="30" height="30" alt="linkedInIcon_holistique" />
          </a>
          <a href="https://www.youtube.com/@holistique2014">
            <img src={youTubeIcon} loading="lazy" width="30" height="30" alt="youTubeIcon_holistique" />
          </a>
          <a href="https://wa.me/50670159340">
            <img src={whatsappIcon} loading="lazy" width="30" height="30" alt="whatsappIcon_holistique" />
          </a>
          <a href="https://www.instagram.com/somosholistique/">
            <img src={instagramIcon} loading="lazy" width="30" height="30" alt="instagramIcon_holistique" />
          </a>
          <a href="https://www.facebook.com/somosholistique/">
            <img src={facebookIcon} loading="lazy" width="30" height="30" alt="facebookIcon_holistique" />
          </a> 
        </div>
      </div>
    </footer>
  );
}